import { createClient } from "@supabase/supabase-js";
import config from "../config";

// URL derivada del host por el que entró el browser (LAN o Tailscale) salvo que
// se fije un dominio con VITE_SUPABASE_URL. Ver resolveSupabaseUrl() en config.ts.
const supabaseUrl = config.SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.warn("Supabase URL or Anon Key missing in environment variables. Auth might fail.");
}

export const supabase = createClient(supabaseUrl || "", supabaseAnonKey || "");
